import { render, staticRenderFns } from "./NewMainLeftMenu.vue?vue&type=template&id=7071e500&"
import script from "./NewMainLeftMenu.vue?vue&type=script&lang=js&"
export * from "./NewMainLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewMainLeftMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports